import { get } from "lodash";

export const isFetching = (state, moduleId, recordId) =>
  get(state, `modules.activity.fetching[${moduleId}][${recordId}]`, false);
export const activity = (state, moduleId, recordId) =>
  get(state, `modules.activity.activity[${moduleId}][${recordId}]`, []);
